'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { Suspense } from 'react';

import {
  getArticleType,
  parseCountryToArticleTerm,
} from '@sola/contentful-model/lib/article.js';
import {
  ArticleTermsEnum,
  ArticleTypesEnum,
} from '@sola/contentful-model/lib/taxonomy-values.js';
import { MergeData } from '@sola/schema/lib/schema.js';

import { ArticleControls } from '../../../molecules/article-group/article-controls';
import {
  ArticleTabs,
  ArticleTabsSkeleton,
} from '../../../molecules/article-group/article-tabs';

const queryClient = new QueryClient();

export const ArticleListCore = ({
  seoLevel = 2,
  articleType,
  term,
  mergeFieldData,
}: {
  seoLevel?: number;
  articleType?: ArticleTypesEnum;
  term?: ArticleTermsEnum;
  mergeFieldData?: MergeData;
}) => {
  const pathname = usePathname();
  const articleTypeClean = articleType || getArticleType(pathname);

  const parseTerm = parseCountryToArticleTerm(mergeFieldData?.pageData);

  return (
    <section className="ArticleListCore component component--no-header">
      <div className="ArticleListCore__container container">
        {!term && articleTypeClean ? (
          <Suspense fallback={<ArticleTabsSkeleton />}>
            <QueryClientProvider client={queryClient}>
              <ArticleTabs seoLevel={seoLevel} articleType={articleTypeClean} />
            </QueryClientProvider>
          </Suspense>
        ) : (
          <ArticleControls
            seoLevel={seoLevel}
            articleType={articleTypeClean}
            term={parseTerm ?? term}
          />
        )}
      </div>
    </section>
  );
};
